import propertyTheftFA from './fa/fa.json'

const PropertyTheftMessages = {
  fa: { ...propertyTheftFA },
}

export default PropertyTheftMessages
